export const FILTER_TYPES = {
	PROCUREMENT: 'PROCUREMENT',
	WORKFLOWS: 'WORKFLOWS',
	PROJECTS: 'PROJECTS', // Legacy type for backward compatibility
	OFFERS: 'OFFERS',
};
